import script from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./ElementToolbar.vue?vue&type=style&index=0&id=1673dff0&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1673dff0"]])

export default __exports__